import { render, staticRenderFns } from "./collectUserInformation.vue?vue&type=template&id=311b5f23&scoped=true"
import script from "./collectUserInformation.vue?vue&type=script&lang=js"
export * from "./collectUserInformation.vue?vue&type=script&lang=js"
import style0 from "./collectUserInformation.vue?vue&type=style&index=0&id=311b5f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b5f23",
  null
  
)

export default component.exports